import { Role } from '@/models/AccountEnums';

/** `/api/user/export` expects the display name for Team Member, as legacy sent. */
export const toExportRole = (role: Role | undefined) =>
  role === Role.TeamMember ? 'Team Member' : role;
